import { defineMessages } from 'react-intl'

const scope = 'modules.vendor.components.creditCardProviderSelect'

export default defineMessages({
  placeholder: {
    id: `${scope}.placeholder`,
    defaultMessage: 'Please select an option',
  },
  ariaLabel: {
    id: `${scope}.ariaLabel`,
    defaultMessage: 'Credit card provider',
  },
  createNewOption: {
    id: `${scope}.createNewOption`,
    defaultMessage: 'Create new',
  },
  createOption: {
    id: `${scope}.createOption`,
    defaultMessage: 'Create "{searchTerm}"',
  },
  manageProvidersOption: {
    id: `${scope}.manageProvidersOption`,
    defaultMessage: 'Manage providers',
  },
})
